import type { HostedSite } from "./HostnameRouting.ts";

export function getSiteHostnames(productionHostname: string) {
    if (!/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/.test(productionHostname)) {
        throw new Error("Specify a lowercase production hostname without a scheme, port, or path.");
    }
    const separator = productionHostname.indexOf(".");
    const dogfood = productionHostname.slice(0, separator) + "-df" + productionHostname.slice(separator);
    return {
        production: productionHostname,
        pilot: `rc.${productionHostname}`,
        dogfood,
        dogfoodPilot: `rc.${dogfood}`,
        local: `local.${dogfood}`,
    };
}

export const primarySiteHostnames = getSiteHostnames("extensionanalyzer.azure-test.net");

export const hostedSites: readonly HostedSite[] = [
    {
        name: "Azure Experiences Learning Systems",
        routePrefix: "/axls",
        hostnames: Object.values(getSiteHostnames("axls.azure-test.net")),
    },
];

export const localDevelopmentHostnames = [
    primarySiteHostnames.local,
    ...hostedSites.flatMap(site => site.hostnames.filter(hostname => hostname.startsWith("local."))),
];
